import { PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { Flex } from '../Flex'
import { Headline2 } from '../Typography'

import { colors } from '@/constants/colors'

type SubSideBarTitleProps = { centered?: boolean }

const TitleWrapper = styled(Flex)<SubSideBarTitleProps>`
  width: 100%;
  align-items: center;
  height: 5rem;
  padding: 1.75rem 1.875rem;
  border-bottom: 0.5px solid ${colors.darkBlue4};
  ${({ centered }) => centered && `justify-content: center`}
`

export default function SubSideBarTitle({
  children,
  centered,
}: PropsWithChildren & SubSideBarTitleProps) {
  return (
    <TitleWrapper centered={centered}>
      <Headline2>{children}</Headline2>
    </TitleWrapper>
  )
}
